import http from "../http-common";

class ClientDataService {
  getAll() {
    return http.get("/clients");
  }

  getClientByDescr(condition, sortfield,sorttype) {
    return http.get(`/clients/search/?clientname=${condition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  get(id) {
    return http.get(`/clients/${id}`);
  }

  create(data) {
    return http.post("/clients/newclient", data);
  }

  update(id, data) {
    return http.put(`/clients/${id}`, data);
  }

  delete(id) {
    return http.delete(`/clients/${id}`);
  }

  deleteAll() {
    return http.delete(`/clients`);
  }

  findById(id) {
    return http.get(`/clients?id=${id}`);
  }
}

export default new ClientDataService();